/**
 * @generated SignedSource<<b00338198aa2a5443fe90e410f9e4c7a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext$data = ReadonlyArray<{
  readonly node: {
    readonly __typename: string;
    readonly category: string | null | undefined;
    readonly issue: {
      readonly __typename: "JiraIssue";
    } | null | undefined;
    readonly url?: AGG$URL | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext";
}>;
export type analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext$key = ReadonlyArray<{
  readonly " $data"?: analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext$data;
  readonly " $fragmentSpreads": FragmentRefs<"analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "analyticsContext_softwareReleasesVersionRelatedWork_RelatedWorkAnalyticsContext",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issue",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        },
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "url"
            }
          ],
          "type": "JiraVersionRelatedWorkGenericLink"
        }
      ]
    }
  ],
  "type": "JiraVersionRelatedWorkV2Edge"
};
})();

(node as any).hash = "aa20d10ea14c3261013e36223676a0c8";

export default node;
